import { useEffect } from 'react'
import CalculatorForm from '../components/CalculatorForm.jsx'
import Seo from '../components/Seo.jsx'

// Standalone calculator meant to be loaded inside an <iframe> on other sites.
// No site chrome (navbar/footer). It reports its height to the parent page so the
// embed snippet can auto-resize the iframe. The backlink that matters for SEO is
// the static <a> in the embed snippet (host-page DOM); the links here drive
// referral traffic from people who use the embedded tool.
export default function Embed() {
  useEffect(() => {
    const post = () => {
      const h = document.documentElement.scrollHeight
      try { window.parent?.postMessage({ cmpEmbedHeight: h }, '*') } catch { /* cross-origin */ }
    }
    post()
    const ro = new ResizeObserver(post)
    ro.observe(document.body)
    window.addEventListener('load', post)
    return () => { ro.disconnect(); window.removeEventListener('load', post) }
  }, [])

  return (
    <div className="embed-wrap">
      <Seo title="Peptide Reconstitution Calculator" noindex />
      <div className="embed-head">
        <a className="embed-title" href="https://calculatemypeptides.com/calculator" target="_blank" rel="noopener">
          Peptide Reconstitution Calculator
        </a>
      </div>
      <CalculatorForm embed />
      <a className="embed-credit" href="https://calculatemypeptides.com/" target="_blank" rel="noopener">
        Powered by <strong>CalculateMyPeptides</strong>
      </a>
    </div>
  )
}
